"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9486],{

/***/ 2839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53893);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 360px;\n  height: 60px;\n  border-radius: 9px;\n  gap: 4px;\n\n  .arrow-icon {\n    width: 18px;\n    height: 18px;\n  }\n\n  > span {\n    font-size: 18px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 240px;\n  height: 48px;\n  border-radius: 8px;\n  gap: 4px;\n  padding: 14px 0;\n\n  .arrow-icon {\n    width: 12px;\n    height: 12px;\n  }\n\n  > span {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  background: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  background-color: #ffffff;\n  border: 1px solid #004eff;\n  color: #004eff;\n  &:hover {\n    background-color: #e6f0ff;\n  }\n\n  > span {\n    font-weight: bold;\n    line-height: 2.39;\n    letter-spacing: -0.72px;\n    text-align: center;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var ExamButton = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        type: "button",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_2__/* .ArrowRight */ .ol, {
                className: "arrow-icon"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ExamButton);
var desktopStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject());
var mobileStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject1());
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "ExamButton__StyledWrapper",
    componentId: "sc-2d42f9db-0"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.isMobile ? mobileStyles : desktopStyles;
});


/***/ }),

/***/ 34626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52737);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53893);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 460px;\n  height: 80px;\n  padding: 23px 57px 22px;\n  font-size: 24px;\n\n  .arrow-icon {\n    width: 18px;\n    height: 18px;\n    margin-left: 4px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 44px;\n  font-size: 16px;\n\n  .arrow-icon {\n    margin-left: 4px;\n    width: 14px;\n    height: 14px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  border-radius: 8px;\n  line-height: 43px;\n  letter-spacing: -0.96px;\n  color: #ffffff;\n  font-weight: bold;\n  cursor: pointer;\n\n  background: linear-gradient(to bottom, #01a0ff, #004eff);\n\n  &:hover {\n    background: linear-gradient(to bottom, #19a9ff, #1a66ff);\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var GradientExamButton = function(_param) {
    var children = _param.children, _type = _param.type, type = _type === void 0 ? "button" : _type, _hasIcon = _param.hasIcon, hasIcon = _hasIcon === void 0 ? true : _hasIcon, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "type",
        "hasIcon"
    ]);
    var isMobile = (0,context__WEBPACK_IMPORTED_MODULE_2__/* .useUA */ .nD)().isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        isMobile: !!isMobile,
        type: type
    }, props), {
        children: [
            children,
            hasIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRight */ .ol, {
                className: "arrow-icon"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (GradientExamButton);
var desktopStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject());
var mobileStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject1());
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "GradientExamButton__StyledWrapper",
    componentId: "sc-3c205fcd-0"
})(_templateObject2(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? mobileStyles : desktopStyles;
});


/***/ }),

/***/ 85655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52737);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: fit-content;\n    height: 34px;\n    border-radius: 17px;\n    background-color: ",
        ";\n    color: ",
        ";\n    font-weight: bold;\n    font-family: 'GmarketSansMedium';\n    line-height: 34px;\n    ",
        "\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 74px;\n  height: 34px;\n  padding: 0 15px;\n  margin: 50px 0 16px;\n  font-size: 16px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 55px;\n  height: 28px;\n  padding: 8px 12px;\n  margin: 0 auto 8px;\n  font-size: 12px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var BenefitChip = function(param) {
    var label = param.label;
    var isMobile = (0,context__WEBPACK_IMPORTED_MODULE_2__/* .useUA */ .nD)().isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        isMobile: !!isMobile,
        children: label
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BenefitChip);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "BenefitChip__StyledWrapper",
    componentId: "sc-f37d1f08-0"
})(_templateObject1(), function(param) {
    var theme = param.theme, isMobile = param.isMobile;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), theme.color.primary_2, theme.background.bg_8, isMobile ? mobileStyles : desktopStyles);
});
var desktopStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2());
var mobileStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3());


/***/ }),

/***/ 22906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52737);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_exam_components_Button_ExamButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2839);
/* harmony import */ var _app_feature_exam_constants_gsatCommunity__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88808);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .study-btn {\n    width: 460px;\n    height: 76px;\n\n    > span {\n      font-size: 22px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .study-btn {\n    width: 100%;\n    height: 50px;\n\n    > span {\n      font-size: 16px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var InterviewStudyLink = function() {
    var isMobile = (0,context__WEBPACK_IMPORTED_MODULE_2__/* .useUA */ .nD)().isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        isMobile: !!isMobile,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: "https://".concat(utils_config__WEBPACK_IMPORTED_MODULE_6__/* .XEN_HOSTNAME */ .Xq, "/").concat(_app_feature_exam_constants_gsatCommunity__WEBPACK_IMPORTED_MODULE_5__/* .SAMSUNG_INTERVIEW_BOARD_SLUG */ .sn),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_feature_exam_components_Button_ExamButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                className: "study-btn",
                color: "gsat",
                children: "삼성 면접 스터디 모집방 바로가기"
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InterviewStudyLink);
var desktopStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject());
var mobileStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject1());
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "InterviewStudyLink__StyledWrapper",
    componentId: "sc-b5089069-0"
})(_templateObject2(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? mobileStyles : desktopStyles;
});


/***/ }),

/***/ 46307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53893);
/* harmony import */ var _app_feature_exam_constants_gsatCommunity__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88808);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  color: #004eff;\n  font-size: 16px;\n  font-weight: bold;\n  letter-spacing: -0.64px;\n  white-space: nowrap;\n\n  .arrow-right {\n    width: 12px;\n    height: 12px;\n    margin-left: 2px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ReviewMoreLink = function() {
    var pathname = "".concat(utils_config__WEBPACK_IMPORTED_MODULE_5__/* .LINKAREER_ACADEMY_COMMUNITY_BASE_URL */ .mw, "/").concat(_app_feature_exam_constants_gsatCommunity__WEBPACK_IMPORTED_MODULE_4__/* .GSAT_REVIEW_PATHNAME */ .Al);
    var query = _app_feature_exam_constants_gsatCommunity__WEBPACK_IMPORTED_MODULE_4__/* .GSAT_REVIEW_SLUG_QUERY */ .rd;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: {
            pathname: pathname,
            query: query
        },
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
            children: [
                "실시간 응시후기 더보기 ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRight */ .ol, {
                    className: "arrow-right"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReviewMoreLink);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    displayName: "ReviewMoreLink__StyledWrapper",
    componentId: "sc-9f013720-0"
})(_templateObject());


/***/ }),

/***/ 10597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ExamTabs_ExamTabs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.feature/exam/hooks/useScrollTab.ts
var useScrollTab = __webpack_require__(36244);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/context.ts + 1 modules
var context = __webpack_require__(52737);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/app.feature/exam/constants/tabs.ts
var tabs = __webpack_require__(82708);
// EXTERNAL MODULE: ./src/app.feature/exam/hooks/useGetIsPreReserved.ts
var useGetIsPreReserved = __webpack_require__(95200);
;// CONCATENATED MODULE: ./src/app.feature/exam/components/Tabs/ExamTabs/Tooltip/ExamTabTooltipDesktop.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 148px;\n    height: 41px;\n    background-color: #f4fbff;\n    border: 2px solid ",
        " !important;\n    border-radius: 18px;\n    box-shadow: 0 2px 4px rgba(2, 2, 2, 0.1);\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: -6px;\n      left: 50%;\n      transform: translateX(-50%) rotate(45deg);\n      width: 10px;\n      height: 10px;\n      background-color: #f4fbff;\n      border-top: 2px solid ",
        " !important;\n      border-left: 2px solid ",
        " !important;\n      z-index: -1;\n    }\n\n    > .tooltip-text {\n      font-size: 15px;\n      font-weight: bold;\n      white-space: nowrap;\n      color: ",
        ";\n      line-height: 1.87;\n      letter-spacing: -0.6px;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var ExamTabTooltipDesktop = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        role: "tooltip",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "tooltip-text",
            children: "가장 빠른 답안 공개!"
        })
    });
};
/* harmony default export */ var Tooltip_ExamTabTooltipDesktop = (ExamTabTooltipDesktop);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ExamTabTooltipDesktop__StyledWrapper",
    componentId: "sc-356df49e-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.color.primary_2, theme.color.primary_2, theme.color.primary_2, theme.color.primary_2);
});

;// CONCATENATED MODULE: ./src/app.feature/exam/components/Tabs/ExamTabs/Tooltip/ExamTabTooltipMobile.tsx

function ExamTabTooltipMobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 112px;\n    height: 33px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 95%;\n    left: 25%;\n    transform: translateX(-50%);\n\n    background-color: #f4fbff;\n    border: 2px solid ",
        " !important;\n    border-radius: 18px;\n    box-shadow: 0 2px 4px rgba(2, 2, 2, 0.1);\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: -5px;\n      left: 90%;\n      transform: translateX(-50%) rotate(45deg);\n      width: 7px;\n      height: 7px;\n      background-color: #f4fbff;\n      border-top: 2px solid ",
        " !important;\n      border-left: 2px solid ",
        " !important;\n      z-index: -1;\n    }\n\n    > .tooltip-text {\n      font-size: 12px;\n      font-weight: bold;\n      white-space: nowrap;\n      color: ",
        ";\n      line-height: 1.87;\n      letter-spacing: -0.6px;\n    }\n  "
    ]);
    ExamTabTooltipMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ExamTabTooltipMobile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ExamTabTooltipMobile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var ExamTabTooltipMobile = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExamTabTooltipMobile_StyledWrapper, {
        role: "tooltip",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "tooltip-text",
            children: "가장 빠른 답안 공개!"
        })
    });
};
/* harmony default export */ var Tooltip_ExamTabTooltipMobile = (ExamTabTooltipMobile);
var ExamTabTooltipMobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ExamTabTooltipMobile__StyledWrapper",
    componentId: "sc-808ed146-0"
})(ExamTabTooltipMobile_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(ExamTabTooltipMobile_templateObject(), theme.color.primary_2, theme.color.primary_2, theme.color.primary_2, theme.color.primary_2);
});

;// CONCATENATED MODULE: ./src/app.feature/exam/components/Tabs/ExamTabs/Tab/ExamTab.tsx



function ExamTab_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 212px;\n  height: 110px;\n  margin: 12px 0;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px 18px;\n  background-color: ",
        ";\n  border-radius: 10px;\n  border: 1px solid #eeeeee;\n  box-shadow: 0 2px 5px 0 rgba(102, 102, 102, 0.16);\n  color: ",
        ";\n  font-weight: bold;\n  transition: all 0.2s ease-in-out;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px 0 rgba(102, 102, 102, 0.25);\n    border-color: ",
        ";\n  }\n\n  &[data-active='true'] {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    > div {\n      color: ",
        ";\n    }\n  }\n\n  > div {\n    font-size: 18px;\n    letter-spacing: -0.72px;\n    padding: 2px 12px;\n    border: 1px solid ",
        ";\n    border-radius: 15px;\n    margin-bottom: 7px;\n    color: #777777;\n  }\n  > span {\n    font-size: 22px;\n    letter-spacing: -0.88px;\n  }\n"
    ]);
    ExamTab_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ExamTab_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n  padding: 8px 6px;\n  border-right: 1px solid #dddddd;\n\n  &[data-active='true'] {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    > div {\n      color: ",
        ";\n    }\n  }\n\n  > img {\n    position: absolute;\n    top: 80px;\n    width: 64px;\n    height: 40px;\n    z-index: 10;\n  }\n\n  > div {\n    width: fit-content;\n    border: 1px solid ",
        ";\n    border-radius: 9px;\n    padding: 1px 7px;\n    white-space: nowrap;\n    font-size: 10px;\n    letter-spacing: -0.4px;\n    font-weight: bold;\n    color: ",
        ";\n  }\n  > span {\n    white-space: pre;\n    font-size: 14px;\n    font-weight: bold;\n    letter-spacing: -0.56px;\n    text-align: center;\n  }\n"
    ]);
    ExamTab_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var ExamTab = function(param) {
    var tab = param.tab, activeTab = param.activeTab, companyId = param.companyId, termId = param.termId;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,context/* useUA */.nD)().isMobile;
    var isShowTooltipPosition = tab.id == tabs/* EXAM_STAGE_TAB.PREDICTION_SCORE */.Ds.PREDICTION_SCORE && activeTab !== tabs/* EXAM_STAGE_TAB.EXAM_VOTE */.Ds.EXAM_VOTE;
    var pathname = router.pathname, query = router.query;
    var iconImageSrc = "/static/images/exam/hand-blue.webp";
    var isPreReserved = (0,useGetIsPreReserved/* default */.Z)({
        companyId: companyId,
        termId: termId
    });
    var preReservedText = tab.id === "full-reservation" ? isMobile ? "풀서비스\n신청하기" : "풀서비스 신청하기" : tab.name;
    var handleClickTab = function() {
        router.replace({
            pathname: pathname,
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                tab: tab.id
            }),
            hash: tab.sectionId
        }, undefined, {
            shallow: true
        });
    };
    var isShowImage = (0,react.useMemo)(function() {
        if (activeTab) {
            var ref;
            var currentIndex = tabs/* EXAM_TAB_OPTIONS.findIndex */.mj.findIndex(function(option) {
                return option.id === activeTab;
            });
            var nextIndex = currentIndex + 1;
            return ((ref = tabs/* EXAM_TAB_OPTIONS */.mj[nextIndex]) === null || ref === void 0 ? void 0 : ref.id) === tab.id;
        } else {
            return tab.id === tabs/* EXAM_TAB_OPTIONS.0.id */.mj[0].id;
        }
    }, [
        activeTab,
        tab.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExamTab_StyledWrapper, {
        "data-active": activeTab === tab.id,
        onClick: handleClickTab,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: tab.label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: isPreReserved ? tab.name : preReservedText
            }),
            isShowImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: iconImageSrc,
                alt: "click"
            }),
            isShowTooltipPosition ? isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_ExamTabTooltipMobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_ExamTabTooltipDesktop, {}) : null
        ]
    });
};
/* harmony default export */ var Tab_ExamTab = (ExamTab);
var desktopStyles = function(theme) {
    return (0,styled_components_browser_esm/* css */.iv)(ExamTab_templateObject(), theme.background.bg_8, theme.color.text_1, theme.color.primary_2, theme.color.primary_2, theme.background.bg_8, theme.background.bg_8, theme.line.line_2);
};
var mobileStyles = function(theme) {
    return (0,styled_components_browser_esm/* css */.iv)(ExamTab_templateObject1(), theme.color.primary_2, theme.background.bg_8, theme.background.bg_8, theme.line.line_2, theme.color.text_1);
};
var ExamTab_StyledWrapper = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "ExamTab__StyledWrapper",
    componentId: "sc-b676fdfe-0"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), theme.isMobile ? mobileStyles(theme) : desktopStyles(theme));
});

;// CONCATENATED MODULE: ./src/app.feature/exam/components/Tabs/ExamTabs/ExamTabs.tsx

function ExamTabs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: sticky;\n  top: 0;\n  z-index: 90;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #fafafa;\n  > ul {\n    display: flex;\n    gap: 10px;\n    width: 1100px;\n  }\n"
    ]);
    ExamTabs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ExamTabs_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: sticky;\n  background-color: #fafafa;\n  top: 50px;\n  z-index: 250;\n\n  > ul {\n    display: flex;\n    width: 100%;\n    height: 93px;\n    > li {\n      flex: 1;\n    }\n  }\n"
    ]);
    ExamTabs_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ExamTabs_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n  "
    ]);
    ExamTabs_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ExamTabs_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ExamTabs_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var ExamTabs = function(param) {
    var companyId = param.companyId, termId = param.termId, tabOptions = param.tabOptions;
    var activeTab = (0,useScrollTab/* default */.Z)().activeTab;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExamTabs_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            children: tabOptions.map(function(tab) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab_ExamTab, {
                    tab: tab,
                    activeTab: activeTab,
                    companyId: companyId,
                    termId: termId
                }, tab.id);
            })
        })
    });
};
/* harmony default export */ var ExamTabs_ExamTabs = (ExamTabs);
var ExamTabs_desktopStyles = (0,styled_components_browser_esm/* css */.iv)(ExamTabs_templateObject());
var ExamTabs_mobileStyles = (0,styled_components_browser_esm/* css */.iv)(ExamTabs_templateObject1());
var ExamTabs_StyledWrapper = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    displayName: "ExamTabs__StyledWrapper",
    componentId: "sc-6dd6ca80-0"
})(ExamTabs_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(ExamTabs_templateObject2(), theme.isMobile ? ExamTabs_mobileStyles : ExamTabs_desktopStyles);
});


/***/ }),

/***/ 82553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  height: 30px;\n  top: 25px;\n  left: -15px;\n  display: flex;\n  padding: 0px 12px;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  font-weight: 600;\n  border: 1px solid #ff0066;\n  color: #ff0066;\n  background-color: #fff;\n  border-radius: 5px;\n  cursor: pointer;\n  ::after {\n    content: '';\n    position: absolute;\n    bottom: -12.5px;\n    left: 10%;\n    border: 7px solid transparent;\n    border-top: 7px solid #fff;\n    transform: translateX(-50%);\n    z-index: 1;\n  }\n  ::before {\n    content: '';\n    position: absolute;\n    bottom: -14px;\n    left: 10%;\n    border: 7px solid transparent;\n    border-top: 7px solid #ff0066;\n    transform: translateX(-50%);\n    z-index: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ButtonTooltip = function(param) {
    var labelText = param.labelText, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        className: className,
        children: labelText
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonTooltip);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ButtonTooltip__StyledWrapper",
    componentId: "sc-4e18f563-0"
})(_templateObject());


/***/ }),

/***/ 61373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ GSAT_SUBJECT_TAB_LIST; }
/* harmony export */ });
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);

var GSAT_SUBJECT_TAB_LIST = [
    {
        id: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ExamSubject.MATH */ .rHe.MATH,
        label: "수리 영역"
    },
    {
        id: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ExamSubject.REASONING */ .rHe.REASONING,
        label: "추리 영역"
    }, 
];


/***/ }),

/***/ 93356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);

var useGetExamChatRoomId = function(param) {
    var chatRoomName = param.chatRoomName;
    var ref, ref1;
    var ref2 = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .useGqlSearchChatRoomsByNameQuery */ .o9f)({
        variables: {
            name: chatRoomName
        }
    }), data = ref2.data, loading = ref2.loading, error = ref2.error;
    if (loading || error) {
        return "";
    }
    return ((ref1 = data === null || data === void 0 ? void 0 : (ref = data.searchChatRoomsByName) === null || ref === void 0 ? void 0 : ref.nodes[0]) === null || ref1 === void 0 ? void 0 : ref1.id) || "";
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetExamChatRoomId);


/***/ }),

/***/ 48915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useQuickScoringAutoFocus; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/app.feature/exam/gsat2024-2/context/TentativeScoringQuestionContext.tsx
var TentativeScoringQuestionContext = __webpack_require__(1074);
// EXTERNAL MODULE: ./src/context.ts + 1 modules
var context = __webpack_require__(52737);
;// CONCATENATED MODULE: ./src/app.feature/exam/modules/createQuestionGroups.ts

var MOBILE_QUICK_QUESTION_SLICE_SIZE = 5;
var DESKTOP_QUICK_QUESTION_SLICE_SIZE = 10;
var createQuestionGroups = function(questions) {
    var isMobile = (0,context/* useUA */.nD)().isMobile;
    var ref;
    var formattedQuestions = (ref = questions === null || questions === void 0 ? void 0 : questions.map(function(question) {
        return {
            id: question.id,
            seq: question.seq,
            predictionAnswer: question.answers && question.answers.length > 0 ? question.answers[0] : null
        };
    })) !== null && ref !== void 0 ? ref : [];
    var groups = [];
    var sliceSize = isMobile ? MOBILE_QUICK_QUESTION_SLICE_SIZE : DESKTOP_QUICK_QUESTION_SLICE_SIZE;
    for(var i = 0; i < formattedQuestions.length; i += sliceSize){
        groups.push(formattedQuestions.slice(i, i + sliceSize));
    }
    return groups;
};
/* harmony default export */ var modules_createQuestionGroups = (createQuestionGroups);

;// CONCATENATED MODULE: ./src/app.feature/exam/hooks/useQuickScoringAutoFocus.ts
// hooks/useQuickScoringAutoFocus.ts





/**
 * 빠른 채점 페이지의 자동 포커스 이동 기능을 제공하는 커스텀 훅
 *
 * 이 훅은 수리 영역과 추리 영역의 문제 그룹을 관리하고,
 * 입력 필드 간 자동 포커스 이동 기능을 제공합니다.
 *
 * 사용자가 한 필드에 값을 입력하면 자동으로 다음 빈 입력 필드로 포커스가 이동합니다.
 * 수리 영역의 마지막 문제를 입력하면 추리 영역의 첫 번째 빈 필드로 포커스가 이동합니다.
 *
 * @returns {TUseQuickScoringAutoFocusReturns} 문제 그룹과 포커스 관련 함수들을 포함하는 객체
 * @returns {Array<Array<TQuestion>>} mathQuestionGroups - 수리 영역 문제 그룹
 * @returns {Array<Array<TQuestion>>} reasoningQuestionGroups - 추리 영역 문제 그룹
 * @returns {Function} registerInput - 입력 필드 참조를 등록하는 함수
 * @returns {Function} focusNextEmptyInput - 다음 빈 입력 필드로 포커스를 이동하는 함수
 */ var useQuickScoringAutoFocus = function() {
    var examGradingQuestionData = (0,react.useContext)(TentativeScoringQuestionContext/* TentativeScoringQuestionContext */.A).examGradingQuestionData;
    var watch = (0,index_esm/* useFormContext */.Gc)().watch;
    var mathQuestionGroups = modules_createQuestionGroups(examGradingQuestionData === null || examGradingQuestionData === void 0 ? void 0 : examGradingQuestionData.math) || [];
    var reasoningQuestionGroups = modules_createQuestionGroups(examGradingQuestionData === null || examGradingQuestionData === void 0 ? void 0 : examGradingQuestionData.reasoning) || [];
    var allMathQuestions = mathQuestionGroups.flat();
    var allReasoningQuestions = reasoningQuestionGroups.flat();
    var inputRefs = (0,react.useRef)({
        math: new Map(),
        reasoning: new Map()
    });
    var registerInput = function(subject, seq, element) {
        if (element) {
            inputRefs.current[subject].set(seq, element);
        } else {
            inputRefs.current[subject].delete(seq);
        }
    };
    var findNextEmptyInput = function(subject, currentSeq) {
        var questions = subject === "math" ? allMathQuestions : allReasoningQuestions;
        var refs = inputRefs.current[subject];
        var currentIndex = questions.findIndex(function(q) {
            return q.seq === currentSeq;
        });
        if (currentIndex === -1) return null;
        for(var i = currentIndex + 1; i < questions.length; i++){
            var question = questions[i];
            var input = refs.get(question.seq);
            var value = watch("".concat(subject, ".inputQuestions.").concat(question.seq - 1, ".selectedAnswer"));
            if (!value && input) {
                return input;
            }
        }
        if (subject === "math") {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = allReasoningQuestions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var question1 = _step.value;
                    var input1 = inputRefs.current.reasoning.get(question1.seq);
                    var value1 = watch("reasoning.inputQuestions.".concat(question1.seq - 1, ".selectedAnswer"));
                    if (!value1 && input1) {
                        return input1;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return null;
    };
    var focusNextEmptyInput = function(subject, currentSeq) {
        var nextInput = findNextEmptyInput(subject, currentSeq);
        if (nextInput) {
            nextInput.focus();
        }
    };
    return {
        mathQuestionGroups: mathQuestionGroups,
        reasoningQuestionGroups: reasoningQuestionGroups,
        registerInput: registerInput,
        focusNextEmptyInput: focusNextEmptyInput
    };
};
/* harmony default export */ var hooks_useQuickScoringAutoFocus = (useQuickScoringAutoFocus);


/***/ }),

/***/ 82307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var PaperPlaneIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "7qnzfvruaa",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        "data-name": "사각형 32246",
                        fill: "#fff",
                        d: "M0 0h21.332v21.336H0z"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                "data-name": "ic / 24 / share / white",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        "data-name": "사각형 32245",
                        fill: "none",
                        d: "M0 0h24v24H0z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        "data-name": "그룹 45159",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            "data-name": "그룹 45158",
                            style: {
                                clipPath: "url(#7qnzfvruaa)"
                            },
                            transform: "translate(1.334 2.332)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                "data-name": "패스 16465",
                                d: "M8.711 13.662a1.465 1.465 0 0 0 .21-.15q2.157-2.152 4.311-4.307a.816.816 0 0 0 .279-.849.769.769 0 0 0-1.211-.407 2.052 2.052 0 0 0-.213.2q-2.146 2.146-4.288 4.3a.272.272 0 0 1-.388.057Q4.172 10.772.923 9.06a1.522 1.522 0 0 1-.914-1.57 1.543 1.543 0 0 1 1.185-1.377Q7.859 3.9 14.518 1.671L19.2.107a1.518 1.518 0 0 1 1.678.361 1.522 1.522 0 0 1 .343 1.661L15.2 20.223a1.559 1.559 0 0 1-2.89.245q-1.761-3.31-3.51-6.623c-.022-.042-.041-.085-.089-.183",
                                style: {
                                    fill: "#fff"
                                }
                            })
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PaperPlaneIcon);


/***/ })

}]);